import "./DisableMobiles.css";
import useWindowDimensions from "@mirage/hooks/useWindowDimensions";
import { Box, Typography } from "@mui/material";
import { PublicPortalTheme } from "@publicPortal/theme/MuiPublicPortal.module";
import React from "react";
import { Outlet } from "react-router-dom";
import BigLogo from "../bigLogo/BigLogo";
import Board from "../board/Board";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDoNotEnter } from "@fortawesome/pro-solid-svg-icons";

const DisableMobiles = () => {
    const { width } = useWindowDimensions();
    if (width < PublicPortalTheme.breakpoints.values.md) {
        return (
            <>
                <BigLogo />
                <Board size="small" headerText="No support for phones" className="disableMobilesBoard">
                    <Box className="disableMobilesBoard__contentContainer">
                        <FontAwesomeIcon icon={faDoNotEnter} color={PublicPortalTheme.palette.error.main} className="disableMobilesBoard__contentContainer__icon" />
                        <Typography variant="h6">We are sorry, but Public Portal is not yet accessible on phone devices, please use the desktop version instead.</Typography>
                    </Box>
                </Board>
            </>
        );
    }
    return <Outlet />;
};

export default DisableMobiles;
